import { render } from "./iconLogout.vue?vue&type=template&id=b1a5760c"
import script from "./iconLogout.vue?vue&type=script&lang=js"
export * from "./iconLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__